import { render, staticRenderFns } from "./ParticipantItem.vue?vue&type=template&id=37ecaf5d&scoped=true"
import script from "./ParticipantItem.vue?vue&type=script&lang=js"
export * from "./ParticipantItem.vue?vue&type=script&lang=js"
import style0 from "./ParticipantItem.vue?vue&type=style&index=0&id=37ecaf5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ecaf5d",
  null
  
)

export default component.exports